module.exports = __webpack_public_path__ + "static/media/0.b804cbc6.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/shadow/0.png
// module id = 1445
// module chunks = 0